var map = {
	"./Nofoto.png": "f2d3",
	"./advertencia.jpg": "49ca",
	"./caritatriste.png": "6415",
	"./imagenMM.gif": "fd70",
	"./loading-icon.gif": "0526",
	"./loading.gif": "f8b2",
	"./logo.png": "4ffd",
	"./logo_banreservas.png": "cd90",
	"./logoleche.jpg": "e0ce",
	"./photothumb.db": "80d6",
	"./stop.png": "bf2e",
	"./user.png": "0f71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";